<app-crudbar-nav [title]="title" [visible]="false" (onReady)="doComReady($event,'crudbar-nav')">
</app-crudbar-nav>

<mat-tab-group #masterTabGroup mat-stretch-tabs="false" mat-align-tabs="start"
  class="h-full"
  style="vertical-align: top;" animationDuration="0ms" dynamicHeight
  (selectedTabChange)="onMasterTabChange($event)">
  <mat-tab #myTabGrid label="瀏覽">
    <div class="border-2 border-red-300">
      <app-jkaggrid #myGrid  [columnDefs]="srv.columnDefs" 
        (afterGridReadyAg)="afterGridReady($event)" (rowClicked)="agRowClicked($event)"
        (rowSelected)="agRowSelected($event)" (onInsert)="doUIInsert($event)"
        (onDelete)="doUIDelete($event)"></app-jkaggrid>

    </div>
  </mat-tab>

  <mat-tab #myTabDetail label="明細">
    <!-- <app-sysse-tabedit [srv]="srv"></app-sysse-tabedit> -->
    <div style="max-height: 400px; overflow-y: auto;">
          <app-jktext  label="下次時間" [value]="item.SE110"     >
    </app-jktext>
    <app-jknumberedit  label="重複頻率" #SE102Com  id="SE102"  [(value)]="item.SE102" [readonly]="true"     >
    </app-jknumberedit>
    <app-jktext  label="時間範圍-起" [value]="item.SE104"     >
    </app-jktext>
    <app-jktext  label="時間範圍-迄" [value]="item.SE105"     >
    </app-jktext>
    <app-jkdatefield  label="開始日期" #SE106Com  id="SE106"  [(value)]="item.SE106" [readonly]="true"     >
    </app-jkdatefield>
    <app-jkdatefield  label="結束日期" #SE107Com  id="SE107"  [(value)]="item.SE107" [readonly]="true"     >
    </app-jkdatefield>
    <app-jknumberedit  label="每月執行日" #SE108Com  id="SE108"  [(value)]="item.SE108" [readonly]="true"     >
    </app-jknumberedit>
    <app-jkdatefield  label="下次日期" #SE109Com  id="SE109"  [(value)]="item.SE109" [readonly]="true"     >
    </app-jkdatefield>
    <app-jkcombobox  label="頻率類型" #SE101Com  id="SE101"  [(value)]="item.SE101" [items]="srv.SysSe101List"  [readonly]="true"     >
    </app-jkcombobox>
    <app-jkdatefield  label="計劃開始日期" #SE111Com  id="SE111"  [(value)]="item.SE111" [readonly]="true"     >
    </app-jkdatefield>
    <app-jktext  label="計劃開始時間" [value]="item.SE112"     >
    </app-jktext>
    <app-jktextarea  height="250px" 
 label="備註" #SE113Com  id="SE113"  [(value)]="item.SE113" [readonly]="true"     >
    </app-jktextarea>
    <app-jktext  label="變動欄位公式-起" [value]="item.SE114"     >
    </app-jktext>
    <app-jktext  label="變動欄位公式-迄" [value]="item.SE115"     >
    </app-jktext>
    <app-jkcombobox  label="MAIL通知方式" #SE116Com  id="SE116"  [(value)]="item.SE116" [items]="srv.SysSe116List"  [readonly]="true"     >
    </app-jkcombobox>
    <app-jktext  label="MAIL帳號" [value]="item.SE117"     >
    </app-jktext>
    <app-jktext  label="程式名稱" [value]="item.NAME1"     >
    </app-jktext>
    <app-jktext  label="定時工作代號" [value]="item.JOBID"     >
    </app-jktext>
    <app-jkcheckboxYN  label="週一" #WEEK1Com  id="WEEK1"  [(valueYN)]="item.WEEK1"  [readonly]="true"     >
    </app-jkcheckboxYN>
    <app-jkcheckboxYN  label="結案碼" #OKCom  id="OK"  [(valueYN)]="item.OK"  [readonly]="true"     >
    </app-jkcheckboxYN>
    <app-jktext  label="公司代號" [value]="item.COMPANYID"     >
    </app-jktext>
    <app-jktext  label="使用者代號" [value]="item.USERID"     >
    </app-jktext>
    <app-jktext  label="程式代號" [value]="item.PROGID"     >
    </app-jktext>
    <app-jkcombobox  label="優先權" #PRIORITYCom  id="PRIORITY"  [(value)]="item.PRIORITY" [items]="srv.SysPriorityList"  [readonly]="true"     >
    </app-jkcombobox>
    <app-jkdatefield  label="設定時間" #DTREQUESTCom  id="DTREQUEST"  [(date)]="item.DTREQUEST" [readonly]="true"     >
    </app-jkdatefield>
    <app-jkcombobox  label="工作類型" #STYLECom  id="STYLE"  [(value)]="item.STYLE" [items]="srv.SysStyleList"  [readonly]="true"     >
    </app-jkcombobox>
    <app-jktext  label="鎖定工作電腦" [value]="item.COMPUTER"     >
    </app-jktext>
    <app-jktext  label="變動欄位" [value]="item.SE100"     >
    </app-jktext>
    <app-jkcheckboxYN  label="週二" #WEEK2Com  id="WEEK2"  [(valueYN)]="item.WEEK2"  [readonly]="true"     >
    </app-jkcheckboxYN>
    <app-jkcheckboxYN  label="週三" #WEEK3Com  id="WEEK3"  [(valueYN)]="item.WEEK3"  [readonly]="true"     >
    </app-jkcheckboxYN>
    <app-jkcheckboxYN  label="週四" #WEEK4Com  id="WEEK4"  [(valueYN)]="item.WEEK4"  [readonly]="true"     >
    </app-jkcheckboxYN>
    <app-jkcheckboxYN  label="週五" #WEEK5Com  id="WEEK5"  [(valueYN)]="item.WEEK5"  [readonly]="true"     >
    </app-jkcheckboxYN>
    <app-jkcheckboxYN  label="週六" #WEEK6Com  id="WEEK6"  [(valueYN)]="item.WEEK6"  [readonly]="true"     >
    </app-jkcheckboxYN>
    <app-jkcheckboxYN  label="週日" #WEEK7Com  id="WEEK7"  [(valueYN)]="item.WEEK7"  [readonly]="true"     >
    </app-jkcheckboxYN>
    <app-jktext  label="每日時分" [value]="item.HHMM"     >
    </app-jktext>
    <app-jktext  label="參數內容" [value]="item.PARAM1"     >
    </app-jktext>

    </div>
  </mat-tab>


  <mat-tab #myTabAdvance label="進階">
    <div class="border-2 min-h-[200px]">[空白]</div>
  </mat-tab>
</mat-tab-group>